module.exports = __webpack_public_path__ + "static/media/SF-7-A.1b0012b0.mp3";